module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_f_normal.0a94e6f6.png";